module.exports = __webpack_public_path__ + "img/ИФ-1(А)-027-m.64f421a5.png";